import Vue from 'vue';
import PrettyCheckbox from 'pretty-checkbox-vue';

Vue.use(PrettyCheckbox);
